<template>
	<div class="info-page-container">
		<div class="header-bg">
			<CInfoMixBackground ref="mixBackground" />
		</div>
		<div class="page-wrapper">
			<div class="page-title"></div>
			<div class="info-wrap">
				<div class="info-logo">
					<CInfoMixLogo ref="mixLogo" />
				</div>
				<div class="base-main-content">
					<div class="base-title text-overflow">{{ getIrName }}</div>
					<div v-if="getIrSlogan" class="base-slogan text-overflow mt-4">"{{ getIrSlogan }}"</div>
					<div v-if="composeInfoAbout.length" class="base-info mt-10">
						<div v-for="(item, index) in composeInfoAbout" :key="index" class="base-info-item">
							{{ item }}
						</div>
					</div>
				</div>
			</div>
			<div class="content-section">
				<div class="content-label">{{ contentLabel }}</div>
				<div class="content-body">
					<m-svg-icon name="double_quotes" class="content-quote-icon" />
					<div v-html="contentText" class="content-text"></div>
				</div>
				<div class="content-btn" @click="handleButtonClick">{{ buttonText }}</div>
			</div>
		</div>
	</div>
</template>

<script>
import CInfoMixBackground from '@rebuild/components/base/CInfoMixBackground.vue';
import CInfoMixLogo from '@rebuild/components/base/CInfoMixLogo.vue';
import { mapGetters } from 'vuex';
import { debounce } from '@/utils/api';

export default {
	components: {
		CInfoMixLogo,
		CInfoMixBackground
	},
	props: {
		// 内容标签文本
		contentLabel: {
			type: String,
			default: ''
		},
		// 内容文本（支持html）
		contentText: {
			type: String,
			default: ''
		},
		// 按钮文本
		buttonText: {
			type: String,
			default: ''
		}
	},
	computed: {
		...mapGetters([
			'getIrBaseInfo',
			'getIrThemeColor',
			'getIrMarketAndCode',
			'getIrName',
			'getIrSlogan',
			'getIrIndustryName'
		]),

		getUpperMarketAndCode() {
			const [market, code] = this.getIrMarketAndCode;
			if (!code) return '';
			return `${code}.${market.toLocaleUpperCase()}`;
		},
		composeInfoAbout() {
			let info = [];
			if (this.getUpperMarketAndCode) info.push(this.getUpperMarketAndCode);
			if (this.getIrIndustryName) info.push(this.getIrIndustryName);
			return info;
		}
	},
	mounted() {
		this.setupBackgroundAndLogo();
	},
	methods: {
		setupBackgroundAndLogo() {
			this.$nextTick(() => {
				const { logo } = this.getIrBaseInfo;
				if (!logo) return;

				this.$refs.mixLogo.drawLogo(logo).then(() => {
					let colorValue = this.getIrThemeColor;
					colorValue = colorValue.toLocaleUpperCase();
					this.$refs.mixBackground?.setMixBgAndColor(logo, colorValue);
				});
			});
		},
		handleButtonClick: debounce(
			function () {
				this.$emit('button-click');
			},
			180,
			true
		)
	}
};
</script>

<style lang="less" scoped>
@import '../../../../style/mixin/mixins.less';
@import '../../../../style/mixin/border-radius.less';

.info-page-container {
	min-height: 100%;
	background-color: #f6f7f8;
	position: relative;

	.header-bg {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		height: 1.4rem;
	}
	.page-wrapper {
		padding: 0 0.14rem;
		overflow: hidden;
	}
	.page-title {
		height: 0.4rem;
		color: #fff;
		font-family: 'PingFang SC';
		font-size: 0.18rem;
		font-style: normal;
		font-weight: 500;
		line-height: 140%; /* 25.2px */
		position: relative;
	}
	.info-wrap {
		margin-top: 0.14rem;
		padding: 0.16rem 0.26rem;
		border-radius: 0.08rem;
		background: #fff;
		box-shadow: 0.09rem 0.16rem 0.12rem 0 rgba(8, 68, 123, 0.05);
		position: relative;

		.info-logo {
			position: absolute;
			top: 0.24rem;
			left: 0.26rem;
			width: 0.64rem;
			height: 0.64rem;
			border-radius: 0.04rem;
			overflow: hidden;
		}
		.base-main-content {
			margin-left: 0.78rem;
			min-height: 0.74rem;

			.base-title {
				max-width: 80%;
				color: #333;
				/* 20/H2-medium */
				font-family: 'PingFang SC';
				font-size: 0.2rem;
				font-style: normal;
				font-weight: 500;
				line-height: 140%; /* 28px */
			}
			.base-slogan {
				color: #989898;
				/* 11/B2-regular */
				font-family: 'PingFang SC';
				font-size: 0.11rem;
				font-style: normal;
				font-weight: 400;
				line-height: 140%; /* 15.4px */
			}
			.base-info {
				font-size: 0;
			}
			.base-info-item {
				padding: 0 0.06rem;
				display: inline-block;
				height: 0.17rem;
				line-height: 0.17rem;

				color: #333;
				/* 11/B2-regular */
				font-family: 'PingFang SC';
				font-size: 0.11rem;
				font-style: normal;
				font-weight: 400;

				& + .base-info-item {
					margin-left: 0.06rem;
				}
			}
		}
	}
	.content-section {
		margin-top: 0.16rem;
		padding: 0.14rem 0.12rem 0.22rem 0.12rem;
		border-radius: 0.04rem;
		background: #fff;

		.content-label {
			color: #333;
			/* 16/H4-medium */
			font-family: 'PingFang SC';
			font-size: 0.16rem;
			font-style: normal;
			font-weight: 500;
			line-height: 140%; /* 22.4px */
			padding-bottom: 0.12rem;
			.thinner-border-bottom(#E8EAEF);
		}
		.content-body {
			margin-top: 0.2rem;
			position: relative;

			.content-quote-icon {
				position: absolute;
				top: 0.07rem;
				right: 0;
				transform: scale(1.66);
				transform-origin: 100% 0;
			}
			.content-text {
				color: #333;
				/* 15/H5-regular */
				font-family: 'PingFang SC';
				font-size: 0.15rem;
				font-style: normal;
				font-weight: 400;
				line-height: 140%; /* 21px */
				white-space: pre-wrap;
				min-height: 0.24rem;
			}
		}
		.content-btn {
			margin: 0 auto;
			margin-top: 0.32rem;
			width: 1.93rem;
			height: 0.44rem;
			text-align: center;
			line-height: 0.44rem;
			border-radius: 0.01rem;
			background: var(--ir-theme-color);

			color: #fff;
			text-align: center;
			font-family: 'PingFang SC';
			font-size: 0.16rem;
			font-style: normal;
			font-weight: 400;
		}
	}
}
</style>
